import { render, staticRenderFns } from "./EstadisticaPrincipal.vue?vue&type=template&id=1159c328&scoped=true&"
import script from "./EstadisticaPrincipal.vue?vue&type=script&lang=js&"
export * from "./EstadisticaPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./EstadisticaPrincipal.vue?vue&type=style&index=0&id=1159c328&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159c328",
  null
  
)

export default component.exports